import request from '@/utils/request'

const base_url = 'https://api.wxls.pro/cms';

// 微信注册
// 获取微信config信息
export function getConfig(data) {
  return request({
    baseURL: base_url,
    url: '/pass/wechat?url=' + data.url,
    method: 'GET',
  });
}
